/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../apiClient'
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from '../../apiClient'
import type {
  ListGrantsQueryResponse,
  ListGrantsQueryParams,
} from '../types/ListGrants'

function getListGrantsUrl() {
  const res = { method: 'GET', url: `/api/v1/nylas/grants/` as const }
  return res
}

/**
 * @summary List grants visible to the current user
 * {@link /api/v1/nylas/grants/}
 */
export async function listGrants(
  params?: ListGrantsQueryParams,
  config: Partial<RequestConfig> & { client?: Client } = {}
) {
  const { client: request = fetch, ...requestConfig } = config

  const res = await request<
    ListGrantsQueryResponse,
    ResponseErrorConfig<Error>,
    unknown
  >({
    method: 'GET',
    url: getListGrantsUrl().url.toString(),
    params,
    ...requestConfig,
  })
  return res.data
}
